// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-swbl-sfzs-index-main_right_content-BUH-2","table":"components-swbl-sfzs-index-table-1gppN"};


//////////////////
// WEBPACK FOOTER
// ./components/swbl/sfzs/index.css
// module id = 2298
// module chunks = 0